import { TEXT_ON_IMAGE_FLOWS } from '../types';

export const SELECT_FLOW_PROMPT_ID = '9d774738-9fdc-46fc-bc5e-d9080f8b426d';

export const PHOTO_SCENES_PROMPT_IDS = {
  [TEXT_ON_IMAGE_FLOWS.SKY]: '2e987b39-7ba6-436f-8a06-e87efc6fcfaf',
  [TEXT_ON_IMAGE_FLOWS.PORTRAIT]: 'ddc8dd94-814e-4b1e-98d3-18e6ffb52394',
  [TEXT_ON_IMAGE_FLOWS.NO_POINT_OF_INTEREST]:
    'ece92fca-dce4-43db-9101-bb5eb8356bac',
  [TEXT_ON_IMAGE_FLOWS.OBJECT]: '2de397d2-6b45-4805-865d-026d5e0a3434',
};

export const RGB_PROMPT_IDS = {
  [TEXT_ON_IMAGE_FLOWS.OBJECT]: '0e7c3417-78d8-419b-bde8-21ca32a041ed',
  [TEXT_ON_IMAGE_FLOWS.DATA_VISUALIZATION]:
    '0bc55fba-6ac7-460d-83ba-0a7d63f98dfc',
};

export const FLUX_PRO_DEPTH_SKY_IMAGE_GENERATION_PROMPT_ID =
  'b369ecb1-37c6-4bdc-a05e-343f2a2ae494';

export const FLUX_PRO_DEPTH_PORTRAIT_IMAGE_GENERATION_PROMPT_ID =
  'fba02a0e-647d-49e4-88b6-e25bdf70c905';

export const FLUX_DEV_NO_POINT_IMAGE_GENERATION_PROMPT_ID =
  'da2b6063-48ef-4409-8083-3b6b0ea29c5b';

export const FLUX_SCHNELL_OBJECT_PROMPT_ID =
  'e6a116cf-147e-4bf1-b61d-4cb752e48e3d';

export const FLUX_DEV_OBJECT_FLOW_FINAL_PROMPT_ID =
  '7cf00aa9-8c43-48a4-baf1-63be627b7ecd';
